<template>
  <div class="alert-dashboard">
    <v-sheet class="dashboard-header-modern" elevation="4">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <div class="header-content">
              <h1 class="dashboard-title white--text">
                <v-icon size="36" color="white" left>mdi-bell-ring</v-icon>
                🏫 ระบบแจ้งเตือนงานวิทยาลัย
              </h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-container fluid class="mt-4">
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <v-card class="summary-card" elevation="8" color="#E3F2FD" :style="{ borderLeft: '6px solid #2196F3' }">
            <v-card-text>
              <div class="d-flex align-center">
                <v-sheet class="summary-icon blue" elevation="2" rounded>
                  <v-icon size="30" color="white">mdi-alert-circle</v-icon>
                </v-sheet>
                <div class="ml-4">
                  <div class="text-caption font-weight-medium grey--text text--darken-1">แจ้งเตือนทั้งหมด</div>
                  <div class="text-h5 font-weight-bold blue--text text--darken-2">{{ totalAlerts }}</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="summary-card" elevation="8" color="#FFEBEE" :style="{ borderLeft: '6px solid #F44336' }">
            <v-card-text>
              <div class="d-flex align-center">
                <v-sheet class="summary-icon red" elevation="2" rounded>
                  <v-icon size="30" color="white">mdi-clock-alert</v-icon>
                </v-sheet>
                <div class="ml-4">
                  <div class="text-caption font-weight-medium grey--text text--darken-1">เร่งด่วน</div>
                  <div class="text-h5 font-weight-bold red--text text--darken-1">{{ urgentAlerts }}</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="summary-card" elevation="8" color="#E8F5E9" :style="{ borderLeft: '6px solid #4CAF50' }">
            <v-card-text>
              <div class="d-flex align-center">
                <v-sheet class="summary-icon green" elevation="2" rounded>
                  <v-icon size="30" color="white">mdi-check-circle</v-icon>
                </v-sheet>
                <div class="ml-4">
                  <div class="text-caption font-weight-medium grey--text text--darken-1">เสร็จสิ้นแล้ว</div>
                  <div class="text-h5 font-weight-bold green--text text--darken-2">{{ completedAlerts }}</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="summary-card" elevation="8" color="#FFF8E1" :style="{ borderLeft: '6px solid #FFC107' }">
            <v-card-text>
              <div class="d-flex align-center">
                <v-sheet class="summary-icon amber darken-1" elevation="2" rounded>
                  <v-icon size="30" color="white">mdi-clock</v-icon>
                </v-sheet>
                <div class="ml-4">
                  <div class="text-caption font-weight-medium grey--text text--darken-1">รอดำเนินการ</div>
                  <div class="text-h5 font-weight-bold amber--text text--darken-3">{{ pendingAlerts }}</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          
          <v-hover v-slot="{ hover }" v-if="periodTeachersAssisstant.period_college_enable === '1' || periodTeachersAssisstant.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #F44336' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="blue darken-1" class="mr-3">mdi-school</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          วิทยาลัย - สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ
                        </h2>                         
                        <p class="text-caption grey--text mb-0">
                            ให้วิทยาลัยดำเนินการก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(periodTeachersAssisstant.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="periodTeachersAssisstant.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="primary"
                        large
                        to="/college/servey_assistant_specialized_licenses"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_college_redirector_A.period_college_enable === '1' || period_college_redirector_A.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #F44336' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="blue darken-1" class="mr-3">mdi-school</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          วิทยาลัย - ประเมินภาค ก คัดเลือกตำแหน่งรองผู้อำนวยการ
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการก่อนระบบปิด เฉพาะวิทยาลัยที่ปรากฎผู้สมัคร
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_college_redirector_A.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_college_redirector_A.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="primary"
                        large
                        to="/college/sedirector_app"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_college_redirector.period_college_enable === '1' || period_college_redirector.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #F44336' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="blue darken-1" class="mr-3">mdi-school</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          วิทยาลัย - รับรายงานตัวรองผู้อำนวยการ
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการก่อนระบบปิด เฉพาะวิทยาลัยที่ได้รับรองผู้อำนวยการ
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_college_redirector.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_college_redirector.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="primary"
                        large
                        to="/college/sedirector_app_report"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_manpower.period_college_enable === '1' || period_teacher_manpower.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-account-group</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการแจ้งข้อมูลสาขาวิชาก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_manpower.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_manpower.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/man_power_j"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-card v-if="nullsCounts >= 1" class="alert-card mb-4" elevation="6" rounded="lg" :style="{ borderLeft: '6px solid #F44336' }">
            <v-card-text class="pa-5">
              <v-row align="center">
                <v-col cols="12" md="8">
                  <div class="d-flex align-start mb-2">
                    <v-icon size="32" color="red darken-1" class="mr-3">mdi-account-multiple-check</v-icon>
                    <div>
                      <h2 class="text-subtitle-1 font-weight-bold">
                        แต่งตั้งคณะกรรมการประเมินครูผู้ช่วย
                      </h2>
                      <p class="text-caption grey--text mb-0">
                        ยังไม่ได้ดำเนินการแต่งตั้งคณะกรรมการประเมินครูผู้ช่วย จำนวน <span class="red--text font-weight-bold">{{ nullsCounts }}</span> ราย
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="alert-actions d-flex flex-column align-md-end align-center">
                    <v-btn
                      color="error"
                      large
                      to="/college/assistantcommitteequalified"
                      class="action-btn"
                      elevation="4"
                      rounded
                    >
                      <v-icon left>mdi-arrow-right-circle</v-icon>
                      ดำเนินการ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-hover v-slot="{ hover }" v-if="periodassteachs.periodAssTeachEnable === '1' || periodassteachs.periodAssTeachEnable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #4CAF50' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="green darken-1" class="mr-3">mdi-school</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">รับรายงานตัวครูผู้ช่วย</h2>
                        <p class="text-caption grey--text mb-0">
                          <span v-if="periodassteachs.periodAssTeachTimes >= 1">
                            รอบ {{ periodassteachs.periodAssTeachTimes }} : {{ periodassteachs.periodAssTeachYear }}
                          </span>
                          <span v-else>
                            รอบคัดเลือกภายใน
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(periodassteachs.periodAssTeachStop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="periodassteachs.periodAssTeachStop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="success"
                        large
                        to="/college/manage_assistant_teacher"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="periodTeachers.period_enable === '1' || periodTeachers.period_enable === 1 && periodTeachers.period_type === 'teacher'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #2196F3' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="info" class="mr-3">mdi-account-edit</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          ปรับปรุงข้อมูลข้าราชการครู
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการปรับปรุงข้อมูลข้าราชการครูเพื่อใช้ในการเสนอย้าย
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(periodTeachers.period_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="periodTeachers.period_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="info"
                        large
                        to="/college/personnel_tem"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_college_moves.period_college_enable === '1' || period_college_moves.period_college_enable === 1 && period_college_moves.period_college_type === 'movement_college'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-file-document</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">แจ้งเงื่อนไขสาขาวิชา</h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการแจ้งเงื่อนไขสาขาวิชาก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_college_moves.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_college_moves.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <div class="action-buttons d-flex align-center">
                        <v-btn
                          v-if="conditions_transfers.documentsLinkfile"
                          color="success"
                          large
                          :href="'/HRvecfiles/' + conditions_transfers.documentsLinkfile"
                          target="_blank"
                          class="action-btn mr-2"
                          elevation="4"
                          rounded
                        >
                          <v-icon left>mdi-check</v-icon>
                          เสร็จสิ้น
                        </v-btn>
                        <template v-else>
                          <v-btn
                            color="warning"
                            large
                            to="/college/conditions_branch"
                            class="action-btn mr-2"
                            elevation="4"
                            rounded
                          >
                            <v-icon left>mdi-arrow-right-circle</v-icon>
                            ดำเนินการ
                          </v-btn>
                          <v-btn
                            color="red"
                            icon
                            @click="VideoDialog()"
                            class="video-btn"
                          >
                            <v-icon>mdi-video</v-icon>
                          </v-btn>
                        </template>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_college_moves_attachment.period_college_enable_file === '1' || period_college_moves_attachment.period_college_enable_file === 1 && period_college_moves_attachment.period_college_type === 'movement_college'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #2196F3' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="info" class="mr-3">mdi-file-upload</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">แนบไฟล์เงื่อนไขสาขาวิชา</h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการแนบไฟล์เงื่อนไขสาขาวิชาก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_college_moves_attachment.period_college_attactmentstop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_college_moves_attachment.period_college_attactmentstop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        v-if="conditions_transfers.documentsLinkfile"
                        color="success"
                        large
                        :href="'/HRvecfiles/' + conditions_transfers.documentsLinkfile"
                        target="_blank"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-check</v-icon>
                        เสร็จสิ้น
                      </v-btn>
                      <v-btn
                        v-else
                        color="info"
                        large
                        to="/college/conditions_branch"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_requests.period_college_enable === '1' || period_teacher_requests.period_college_enable === 1 && period_teacher_requests.period_college_type === 'teacher_request'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #F44336' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="red darken-1" class="mr-3">mdi-file-document-multiple</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          แนบไฟล์แบบคำร้องขอย้ายและเอกสารประกอบ
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการแนบไฟล์แบบคำร้องขอย้ายและเอกสารประกอบการพิจารณา
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_requests.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_requests.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <div class="action-buttons d-flex align-center">
                        <v-btn
                          color="error"
                          large
                          to="/college/transference_personnel"
                          class="action-btn mr-2"
                          elevation="4"
                          rounded
                        >
                          <v-icon left>mdi-arrow-right-circle</v-icon>
                          ดำเนินการ
                        </v-btn>
                        <v-btn
                          color="red"
                          icon
                          @click="VideoDialogCondition()"
                          class="video-btn"
                        >
                          <v-icon>mdi-video</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="perioddiscuss.period_college_enable === '1' || perioddiscuss.period_college_enable === 1 && perioddiscuss.period_college_type === 'discuss_college'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-account-supervisor</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          ขอความคิดเห็นจากคณะกรรมการวิทยาลัย - รับย้ายสายบริหาร
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการขอความคิดเห็นจากคณะกรรมการวิทยาลัยต่อผู้ประสงค์ขอย้ายเข้า รับย้ายสายบริหาร
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(perioddiscuss.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="perioddiscuss.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/transference_manage_location"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_moves.period_college_enable === '1' || period_teacher_moves.period_college_enable === 1 && period_teacher_moves.period_college_type === 'discuss_teacher'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #4CAF50' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="green darken-1" class="mr-3">mdi-account-group</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          ขอความคิดเห็นจากคณะกรรมการวิทยาลัย - รับย้ายสายการสอน
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ดำเนินการขอความคิดเห็นจากคณะกรรมการวิทยาลัยต่อผู้ประสงค์ขอย้ายเข้า รับย้ายสายการสอน (ครู)
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_moves.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_moves.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="success"
                        large
                        to="/college/transference_personnel_movein"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_colleges.period_college_enable === '1' || period_colleges.period_college_enable === 1 && period_colleges.period_college_type === 'update_college'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #2196F3' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="info" class="mr-3">mdi-chart-line</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">รายงานอัตรากำลัง</h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรายงานอัตรากำลังก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_colleges.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_colleges.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="info"
                        large
                        to="/college/personnel_etc"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_colleges_reportmv.period_college_enable === '1' || period_colleges_reportmv.period_college_enable === 1 && period_colleges_reportmv.period_college_type === 'reportmove_teacher'">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #4CAF50' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="green darken-1" class="mr-3">mdi-account-check</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">รับรายงานตัวย้ายกรณีปกติ</h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรับรายงานตัวครูย้ายก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_colleges_reportmv.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_colleges_reportmv.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="success"
                        large
                        to="/college/conditons_transfer_success"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_govem_report.period_college_enable === '1' || period_teacher_govem_report.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #4CAF50' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="green darken-1" class="mr-3">mdi-account-check</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          รับรายงานตัวย้าย พนักงานราชการ กรณีปกติ
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรับรายงานตัว พนักงานราชการ ก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_govem_report.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_govem_report.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="success"
                        large
                        to="/college/conditons_transfer_success_gov"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_govem_manpower_report.period_college_enable === '1' || period_teacher_govem_manpower_report.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-briefcase</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          พนักงานราชการ - สถานศึกษารายงานการการบริหารอัตรากำลัง 
                          และการเบิกจ่ายค่าตอบแทน
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรายงานก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_govem_manpower_report.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_govem_manpower_report.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/gov_em/government_employee"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_committee_report.period_college_enable === '1' || period_committee_report.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-briefcase</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          เสนอรายชื่อ ศึกษานิเทศก์ หรือผู้ทรงคุณวุฒิ ก.ค.ศ. ที่ ศธ 0206.7/ว 19 ลงวันที่ 19 สิงหาคม 2568
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรายงานก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_committee_report.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_committee_report.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/assistantcommitteequalified"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_govem_manpower.period_college_enable === '1' || period_teacher_govem_manpower.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-briefcase</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          พนักงานราชการ - รายงานการสำรวจตำแหน่งว่าง
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรายงานการสำรวจตำแหน่งว่างพนักงานราชการก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_govem_manpower.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_govem_manpower.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/conditions_branch_govem"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot="{ hover }" v-if="period_teacher_govem_file.period_college_enable === '1' || period_teacher_govem_file.period_college_enable === 1">
            <v-card :elevation="hover ? 16 : 6" class="alert-card mb-4" rounded="lg" :class="{'on-hover': hover}" :style="{ borderLeft: '6px solid #FF9800' }">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="8">
                    <div class="d-flex align-start mb-2">
                      <v-icon size="32" color="orange darken-1" class="mr-3">mdi-briefcase</v-icon>
                      <div>
                        <h2 class="text-subtitle-1 font-weight-bold">
                          พนักงานราชการ - รวบรวมคำร้องขอย้าย ตำแหน่งพนักงานราชการ
                        </h2>
                        <p class="text-caption grey--text mb-0">
                          ให้วิทยาลัยดำเนินการรวบรวมคำร้องขอย้าย ตำแหน่งพนักงานราชการ ก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-center ml-2">
                      <v-icon color="error" small class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="deadline-text text-body-2 font-weight-medium">
                        ปิดระบบ: {{ formatDeadline(period_teacher_govem_file.period_college_stop) }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="alert-actions d-flex flex-column align-md-end align-center">
                      <flip-countdown
                        :deadline="period_teacher_govem_file.period_college_stop + ' 16:30:00'"
                        :labels="labels"
                        class="countdown-timer mb-3"
                      ></flip-countdown>
                      <v-btn
                        color="warning"
                        large
                        to="/college/transference_personnel_govem"
                        class="action-btn"
                        elevation="4"
                        rounded
                      >
                        <v-icon left>mdi-arrow-right-circle</v-icon>
                        ดำเนินการ
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>
          
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="VideoDialogYoutubeConditionbranch" max-width="600" persistent>
      <v-card rounded="lg">
        <v-card-title class="text-h6 primary white--text">
          <v-icon class="mr-2" color="white">mdi-video</v-icon>
          วิดีโอแนะนำการใช้งาน - เงื่อนไขสาขาวิชา
        </v-card-title>
        <v-card-text class="py-4 text-center">
          <div class="video-placeholder">
            <p class="text-body-1 grey--text">วิดีโอแนะนำการใช้งานระบบเงื่อนไขสาขาวิชา</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="VideoDialogYoutubeConditionbranch = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="VideoDialogYoutubeManageMovement" max-width="600" persistent>
      <v-card rounded="lg">
        <v-card-title class="text-h6 primary white--text">
          <v-icon class="mr-2" color="white">mdi-video</v-icon>
          วิดีโอแนะนำการใช้งาน - การจัดการย้าย
        </v-card-title>
        <v-card-text class="py-4 text-center">
          <div class="video-placeholder">
            <p class="text-body-1 grey--text">วิดีโอแนะนำการใช้งานระบบการจัดการย้าย</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="VideoDialogYoutubeManageMovement = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      rounded="lg"
    >
      <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  components: { FlipCountdown },
  name: "CollegeAlert",
  props: {
    // Define props if needed
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      user: {},
      periods: [],
      adduserdialog: false,
      VideoDialogYoutubeManageMovement: false,
      VideoDialogYoutubeConditionbranch: false,
      VideoDialogYoutubeAssessmentDevTeach: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      labels: {
        days: "วัน",
        hours: "ชม.", // ใช้ตัวย่อเพื่อให้กระชับ
        minutes: "นาที",
        seconds: "วิ." // ใช้ตัวย่อเพื่อให้กระชับ
      },
      period_colleges: {},
      period_college_moves: {},
      period_college_moves_attachment: {},
      period_teacher_moves: {},
      period_teacher_manpower: {},
      perioddiscuss: {},
      periodTeachers: {},
      periodManages: {},
      period_teacher_requests: {},
      period_vecprovinceTeacher: {},
      period_vecprovincemanage: {},
      periodassteachs: {},
      period_colleges_reportmv: {},
      conditions_transfers: {},
      manage_assistant_teachers: [],
      nullsCounts: 0,
      period_college_redirector: {},
      period_college_redirector_A: {},
      period_teacher_govem_manpower: {},
      period_teacher_govem_file: {},
      period_teacher_govem_report: [],
      periodTeachersAssisstant: [],
      period_teacher_govem_manpower_report:{},
      period_committee_report:{}
    };
  },
  computed: {
    totalAlerts() {
      let count = 0;
      if (this.periodTeachersAssisstant.period_college_enable === '1' || this.periodTeachersAssisstant.period_college_enable === 1) count++;
      if (this.period_college_redirector_A.period_college_enable === "1" || this.period_college_redirector_A.period_college_enable === 1) count++;
      if (this.period_college_redirector.period_college_enable === "1" || this.period_college_redirector.period_college_enable === 1) count++;
      if (this.period_teacher_manpower.period_college_enable === "1" || this.period_teacher_manpower.period_college_enable === 1) count++;
      if (this.nullsCounts >= 1) count++;
      if (this.periodassteachs.periodAssTeachEnable === "1" || this.periodassteachs.periodAssTeachEnable === 1) count++;
      if (this.periodTeachers.period_enable === "1" && this.periodTeachers.period_type === "teacher") count++;
      if (this.period_college_moves.period_college_enable === "1" && this.period_college_moves.period_college_type === "movement_college") count++;
      if (this.period_college_moves_attachment.period_college_enable_file === "1" && this.period_college_moves_attachment.period_college_type === "movement_college") count++;
      if (this.period_teacher_requests.period_college_enable === "1" && this.period_teacher_requests.period_college_type === "teacher_request") count++;
      if (this.perioddiscuss.period_college_enable === "1" && this.perioddiscuss.period_college_type === "discuss_college") count++;
      if (this.period_teacher_moves.period_college_enable === "1" && this.period_teacher_moves.period_college_type === "discuss_teacher") count++;
      if (this.period_colleges.period_college_enable === "1" && this.period_colleges.period_college_type === "update_college") count++;
      if (this.period_colleges_reportmv.period_college_enable === "1" && this.period_colleges_reportmv.period_college_type === "reportmove_teacher") count++;
      if (this.period_teacher_govem_manpower.period_college_enable === "1" || this.period_teacher_govem_manpower.period_college_enable === 1) count++;
      if (this.period_teacher_govem_manpower_report.period_college_enable === "1" || this.period_teacher_govem_manpower_report.period_college_enable === 1) count++;
      if (this.period_teacher_govem_file.period_college_enable === "1" || this.period_teacher_govem_file.period_college_enable === 1) count++;
      if (this.period_teacher_govem_report.period_college_enable === "1" || this.period_teacher_govem_report.period_college_enable === 1) count++;
      if (this.period_committee_report.period_college_enable === "1" || this.period_committee_report.period_college_enable === 1) count++;
      return count;
    },
    urgentAlerts() {
      let count = 0;
      if (this.periodTeachersAssisstant.period_college_enable === '1' || this.periodTeachersAssisstant.period_college_enable === 1) count++;
      if (this.period_college_redirector_A.period_college_enable === "1" || this.period_college_redirector_A.period_college_enable === 1) count++;
      if (this.period_college_redirector.period_college_enable === "1" || this.period_college_redirector.period_college_enable === 1) count++;
      if (this.nullsCounts >= 1) count++;
      if (this.period_teacher_requests.period_college_enable === "1" || this.period_teacher_requests.period_college_enable === 1) count++;
      return count;
    },
    completedAlerts() {
      let count = 0;
      if (this.conditions_transfers.documentsLinkfile) count++;
      return count;
    },
    pendingAlerts() {
      return this.totalAlerts - this.completedAlerts;
    }
  },
  async mounted() {
    await this.initializeData();
  },
  methods: {
    async initializeData() {
      try {
        await this.periodQueryTeacherAssisstant();
        await this.getuser();
        await this.periodQuery();
        await this.period_teacher_govem_fileQuery();
        await this.manage_assistant_teacherQueryAll();
        await this.periodassteachQuery();
        await this.periodQueryTeacher();
        await this.periodQueryManage();
        await this.teacher_requestQuery();
        await this.period_college_moveQuery();
        await this.period_teacher_moveQuery();
        await this.periodDiscussQuery();
        await this.period_collegeQuery();
        await this.period_collegemvQuery();
        await this.period_collegeSedirectors();
        await this.period_college_move_attachment();
        await this.period_collegeSedirectors_A();
        await this.period_collegeManpower();
        await this.period_collegeGovem();
        await this.period_collegeGovemManpower();
        await this.period_teacher_govem_ReportQuery();
        await this.period_committee_reportQuery();
      } catch (error) {
        console.error("Error initializing data:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
      }
    },

    async period_committee_reportQuery() {
      try {
        let result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "60101"
        });
        this.period_committee_report = result.data || {};
      } catch (error) {
        console.error("Error fetching committee report period:", error);
        this.period_committee_report = {};
      }
    },  

    formatDeadline(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    },

    VideoDialog() {
      this.VideoDialogYoutubeConditionbranch = true;
    },

    VideoDialogCondition() {
      this.VideoDialogYoutubeManageMovement = true;
    },

    showSnackbar(text, color = "success", icon = "mdi-check") {
      this.snackbar = {
        show: true,
        text: text,
        color: color,
        icon: icon,
        timeout: 5000
      };
    },

    async getuser() {
      try {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        if (userSession.user_name) {
          let result = await this.$http.post("admin.php", {
            user_name: userSession.user_name,
            ApiKey: this.ApiKey
          });
          this.user = result.data || {};
        }
      } catch (error) {
        console.error("Error getting user:", error);
        this.user = {};
      }
    },

    async period_collegeGovem() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "801"
          }
        );
        this.period_teacher_govem_manpower = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_manpower = {};
      }
    },


     async period_collegeGovemManpower() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "80104"
          }
        );
        this.period_teacher_govem_manpower_report = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_manpower_report = {};
      }
    },


    async period_teacher_govem_fileQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "80101"
          }
        );
        this.period_teacher_govem_file = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_file = {};
      }
    },

    async period_teacher_govem_ReportQuery() {
      try {
        let result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "80103"
        });
        this.period_teacher_govem_report = result.data || {};
        
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_report = {};
      }
    },

    async period_collegeManpower() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "701"
          }
        );
        this.period_teacher_manpower = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching teacher manpower period:", error);
        this.period_teacher_manpower = {};
      }
    },

    async period_collegeSedirectors_A() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "20100"
          }
        );
        this.period_college_redirector_A = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college directors A period:", error);
        this.period_college_redirector_A = {};
      }
    },

    async period_collegeSedirectors() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "20101"
          }
        );
        this.period_college_redirector = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college directors period:", error);
        this.period_college_redirector = {};
      }
    },

    async manage_assistant_teacherQueryAll() {
      try {
        if (!this.user || !this.user.user_code) {
          this.nullsCounts = 0;
          return;
        }

        let result = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_college_code: this.user.user_code,
          mt_admissions_status: "receipt"
        });
        this.manage_assistant_teachers = result.data || [];

        if (this.manage_assistant_teachers.length > 0) {
          let data = this.manage_assistant_teachers;
          let sum = 0;
          let countcf = 0;
          data.forEach(value => {
            sum += 1;
            if (value.mt_committe_status == "CF") {
              countcf += 1;
            }
          });
          let nullsCounts = sum - countcf;
          this.nullsCounts = parseInt(nullsCounts);
        } else {
          this.nullsCounts = 0;
        }
      } catch (error) {
        console.error("Error fetching assistant teachers:", error);
        this.manage_assistant_teachers = [];
        this.nullsCounts = 0;
      }
    },

    async teacher_requestQuery() {
      try {
        let result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_type: "teacher_request"
        });
        this.period_teacher_requests = result.data || {};
      } catch (error) {
        console.error("Error fetching teacher request period:", error);
        this.period_teacher_requests = {};
      }
    },

    async period_college_moveQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_type: "movement_college"
          }
        );
        this.period_college_moves = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college move period:", error);
        this.period_college_moves = {};
      }
    },

    async period_college_move_attachment() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable_file: "1",
            period_college_type: "movement_college"
          }
        );
        this.period_college_moves_attachment = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college move attachment period:", error);
        this.period_college_moves_attachment = {};
      }
    },

    async period_teacher_moveQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_type: "discuss_teacher"
          }
        );
        this.period_teacher_moves = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching teacher move period:", error);
        this.period_teacher_moves = {};
      }
    },

    async periodDiscussQuery() {
      try {
        let result_period = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_type: "discuss_college"
        });
        this.perioddiscuss = result_period.data || {};
      } catch (error) {
        console.error("Error fetching discuss period:", error);
        this.perioddiscuss = {};
      }
    },

    async period_collegeQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_type: "update_college"
          }
        );
        this.period_colleges = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college period:", error);
        this.period_colleges = {};
      }
    },

    async period_collegemvQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_type: "reportmove_teacher"
          }
        );
        this.period_colleges_reportmv = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching college report move period:", error);
        this.period_colleges_reportmv = {};
      }
    },

    async periodassteachQuery() {
      try {
        let result = await this.$http.post("periodassteach.php", {
          ApiKey: this.ApiKey,
          periodAssTeachEnable: "1"
        });
        this.periodassteachs = result.data || {};
      } catch (error) {
        console.error("Error fetching assistant teach period:", error);
        this.periodassteachs = {};
      }
    },

    async periodQueryTeacher() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable: "1",
          period_type: "teacher"
        });
        this.periodTeachers = result.data || {};
      } catch (error) {
        console.error("Error fetching teacher period:", error);
        this.periodTeachers = {};
      }
    },


    async periodQueryTeacherAssisstant() {
      try {
        let result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "601",
        });
        this.periodTeachersAssisstant = result.data || {};
      } catch (error) {
        console.error("Error fetching teacher period:", error);
        this.periodTeachersAssisstant = {};
      }
    },


    async periodQueryManage() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable: "1",
          period_type: "manage"
        });
        this.periodManages = result.data || {};
      } catch (error) {
        console.error("Error fetching manage period:", error);
        this.periodManages = {};
      }
    },

    async periodQuery() {
      try {
        let result_period = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_enable: "1",
          period_type: "manage",
          periord_admin: "check"
        });
        this.periods = result_period.data || [];
      } catch (error) {
        console.error("Error fetching periods:", error);
        this.periods = [];
      }
    }
  }
};
</script>
<style scoped>
/* Global App Styles for this component */
.alert-dashboard {
  background: #f5f7fa; /* Light background for the dashboard area */
  min-height: 100vh;
}

/* Header Section */
.dashboard-header-modern {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 0;
  border-radius: 0 0 15px 15px !important;
}

.dashboard-title {
  font-size: 2.2rem;
  font-weight: 700;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

/* Summary Cards */
.summary-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  /* border-left set via inline style for dynamic color */
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}

.summary-icon {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 10px !important;
}

/* Alert Cards */
.alert-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
  /* border-left set via inline style for status */
}

.alert-card.on-hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.1) !important;
}

/* Actions and Countdown */
.alert-actions {
  /* gap set implicitly by margin/padding and d-flex */
  gap: 10px;
}

.action-btn {
  border-radius: 20px !important; /* Pill shape */
  font-weight: 600 !important;
  text-transform: none !important;
  min-width: 150px;
}

.video-btn {
  /* Using v-btn icon in template */
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
}

/* Countdown Timer Styles (Requires :deep() for scoped CSS) */
.countdown-timer >>> .flip-countdown {
  font-family: "Roboto", sans-serif;
}
.countdown-timer >>> .flip-countdown__piece {
  background: #37474f; /* Darker background */
  color: white;
  border-radius: 4px;
  font-size: 0.85rem;
  min-width: 30px;
  height: 30px;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.65rem;
  color: #777;
  margin-top: 5px;
}

/* Deadline Text */
.deadline-text {
  color: #e53935; /* Color error */
  font-weight: 600;
}

/* Video Dialog Placeholder */
.video-placeholder {
  min-height: 250px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ccc;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-title {
    font-size: 1.8rem;
  }
  .text-subtitle-1 {
    font-size: 1rem !important;
  }
  .action-btn {
    min-width: 120px;
  }
  .alert-actions {
    flex-direction: row;
    justify-content: center;
  }
  .alert-actions .action-buttons {
    flex-direction: row;
  }
}
</style>